export default __webpack_public_path__ + "static/media/next.a1d49489.svg";